import { useEffect, useState } from 'react';

/**
 * Funding progress — always computed from the `_minor` integer fields
 * (never the decimal display strings), per the spec's guidance that
 * `_minor` values are the ones safe for math. Shared by the admin
 * investment detail screen and the investor-side list/detail screens.
 *
 * Fill animates from 0 on first mount (design system's "progress bars
 * animate fill on first render" rule) — starts at width 0 and flips to the
 * real percentage one tick later so the CSS transition actually has
 * something to animate, rather than snapping straight to its final width.
 */
export default function FundingProgressBar({ fundedMinor, principalMinor }) {
  const pct = principalMinor > 0 ? Math.min(100, Math.round((fundedMinor / principalMinor) * 100)) : 0;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setWidth(pct));
    return () => cancelAnimationFrame(raf);
  }, [pct]);

  return (
    <div>
      <div className="h-2 rounded-full bg-background-elevated overflow-hidden">
        <div className="h-full bg-accent transition-all duration-700 ease-out" style={{ width: `${width}%` }} />
      </div>
      <p className="mt-1 text-xs text-foreground-subtle">{pct}% funded</p>
    </div>
  );
}
